<template>
	<div class="layerPop" id="popMemoW" v-if="isVisible">
		<div class="popWrap">
			<div class="popBox popType2">
				<div class="popHead">
					<p class="popTit">메모를 확인해 주세요</p>
				</div>

				<div class="popCon">
					<div class="memoView">
						메모내용
					</div>
				</div>
				<div class="popBtn">
					<a  class="btnType sizeS colorBL"><span>수정</span></a>
					<a  class="btnType sizeS colorB"><span>확인</span></a>
				</div>
				<button type="button" class="popClose" onclick="popClose(this);"><span class="hide">닫기</span></button>


			</div>
		</div>
	</div>
</template>

<script setup>
import {ref , defineEmits , defineExpose} from 'vue'

const isVisible = ref(false);

const emits = defineEmits(['update:data' ,'close']);

const open = () => {
 	isVisible.value =true;
}

const send = () => {
  const data = {}
}

const close = () => {
	isVisible.value =false;
	emits('close');
}

defineExpose({open , close})

</script>